import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import Login from './auth/Login';
import Dashboard from './dashboard/dashboard';
import PrivateRoute from './Components/PrivateRoute';
import AssetsDatabase from './pages/AssetsDatabase';
import InspectionScheduling from './pages/InspectionScheduling';
import ActionItems from './pages/ActionItems';
import Administration from './pages/Administration';
import EquipmentProfilePage from './Components/EquipmentProfilePage';
import ValveProfilePage from './pages/ValveProfilePage';
import Valves from './pages/Valves';
import SiteFilesPage from './pages/SiteFilesPage';
import BoilerMatricesPage from './pages/BoilerMatricesPage';
import BoilerModuleRoute from './Components/BoilerModuleRoute';
import ReliabilityChampionshipPage from './pages/ReliabilityChampionshipPage';


import Home from './pages/Home';

// Admin Subpages
import UserManagement from './pages/admin/UserManagement';
import EquipmentManagement from './pages/admin/EquipmentManagement';
import CompanyManagement from './pages/admin/CompanyManagement';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/equipment/:equipmentId/profile" element={<EquipmentProfilePage />} />
        <Route path="/valves/:valveId/profile" element={<ValveProfilePage />} />
        <Route path="/maintenance-reliability-championship-2027" element={<ReliabilityChampionshipPage />} />
        


        {/* Private Routes */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/assets_database"
          element={
            <PrivateRoute>
              <AssetsDatabase />
            </PrivateRoute>
          }
        />
        <Route
          path="/valves"
          element={
            <PrivateRoute>
              <Valves />
            </PrivateRoute>
          }
        />
        <Route
          path="/boiler-matrices"
          element={
            <PrivateRoute>
              <BoilerModuleRoute>
                <BoilerMatricesPage />
              </BoilerModuleRoute>
            </PrivateRoute>
          }
        />
        <Route
  path="/site-files"
  element={
    <PrivateRoute>
      <SiteFilesPage />
    </PrivateRoute>
  }
/>
        <Route
          path="/inspection_scheduling"
          element={
            <PrivateRoute>
              <InspectionScheduling />
            </PrivateRoute>
          }
        />
        <Route
          path="/action-items"
          element={
            <PrivateRoute>
              <ActionItems />
            </PrivateRoute>
          }
        />
        <Route
          path="/administration"
          element={
            <PrivateRoute allowedRoles={['ADMIN', 'SUPER_ADMIN']}>
              <Administration />
            </PrivateRoute>
          }
        />
        <Route
          path="/administration/userManagement"
          element={
            <PrivateRoute allowedRoles={['ADMIN', 'SUPER_ADMIN']}>
              <UserManagement />
            </PrivateRoute>
          }
        />
        <Route
          path="/administration/companyManagement"
          element={
            <PrivateRoute allowedRoles={['ADMIN', 'SUPER_ADMIN']}>
              <CompanyManagement/>
            </PrivateRoute>
          }
        />
        <Route
          path="/administration/equipmentManagement"
          element={
            <PrivateRoute allowedRoles={['ADMIN', 'SUPER_ADMIN']}>
              <EquipmentManagement />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
